<template>
    <g class="label-group"
       :class="labelClass()">
        <polygon :points="polygonsPosition()" class="label-drag-polygone" v-if="!label.isDrawing"/>
        
        <!-- Creation du polygon -->
        <polyline :points="polygonsPosition()" class="label-polyline" v-if="label.isDrawing"/>
        <circle
            v-if="label.isDrawing && label.points.length > 2"
            :cx="pointPositionX(label.points[0].x)"
            :cy="pointPositionY(label.points[0].y)"
            r="8"
            class="label-areas-pointer grab"
            @click="stopDraw()"
        />
        
    
        <!-- Affichage/modification du polygon -->
        <polygon
            :points="polygonsPosition()"
            class="label-polygone"
            @mouseenter="$emit('hover')"
            @mouseleave="stopDragDelay"
            @mousedown="startDrag($event)"
            @mouseup="stopDrag()"
            @click="$emit('select')"
            @dblclick.stop="$emit('edit')"
            ref="label-areas" v-if="!label.isDrawing"/>

        <line
            v-for="(point, k) in label.points"
            :key="k"
            v-if="selected && !label.isDrawing"
            :x1="pointPositionX(point.x)"
            :y1="pointPositionY(point.y)"
            :x2="pointPositionX(label.points[k === label.points.length - 1 ? 0 : k+1].x)"
            :y2="pointPositionY(label.points[k === label.points.length - 1 ? 0 : k+1].y)"
            class="label-areas-line"
            @click="addPointOnLine($event,k)"
        />
        
        <circle
            v-for="(point, k) in label.points"
            :key="k"
            v-if="selected && !label.isDrawing"
            :cx="pointPositionX(point.x)"
            :cy="pointPositionY(point.y)"
            r="8"
            class="label-areas-pointer"
            :class="{'hover':point.hover}"
            @mouseenter="hoverPointer(k)"
            @mouseleave="unhoverPointer(k)"
            @mousedown="startDragPointer($event,k)"
            @mouseup="stopDragPointer()"
            ref="label-areas-pointer"
        />
    </g>

</template>

<script>
    import Tools from "../../class/tools";
    import events from "@/events/events";

    export default {
        name: "Areas_Pointer",
        props: {
            label: {},
            imageData: {type: Object},
            selected: {type: Boolean},
            hovered: {type: Boolean}
        },
        data() {
            return {
                start: false,
                drag: false,
                dragMove : false,
                dragOffset: {
                    x: 0,
                    y: 0
                },
                prevMouseX: 0,
                prevMouseY: 0,

                dragPointer: -1,
                
                drawMousePosition:{x:0,y:0},
            }
        },
        methods: {
            startDrag($event) {
                this.start = true;
                this.dragPointer = -1;
                setTimeout(() => {
                    if (this.start) {
                        this.drag = true;

                        this.dragOffset.x = $event.pageX - this.$refs["label-areas"].getBoundingClientRect().left;
                        this.dragOffset.y = $event.pageY - this.$refs["label-areas"].getBoundingClientRect().top;

                        this.prevMouseX = null;
                        this.prevMouseY = null;

                        this.$emit('select');
                        this.$emit('drag');
                        events.$on("body:click:mouse:up",this.stopDrag)
                    }
                }, this.$store.getters.getDelayBeforeDrag)
            },
            stopDrag() {
                this.start = false;
                
                if(this.dragMove) {
                    this.label.save();
                }
                
                this.drag = false;
                this.dragMove = false;
                this.$emit('undrag');
                events.$off("body:click:mouse:up",this.stopDrag)
            },
            stopDragDelay() {
                if (this.start && !this.drag) {
                    this.start = false;
                    this.drag = false;
                }
                if (!this.drag) {
                    this.$emit('unhover')
                }
            },
            startDragPointer($event, k) {
                this.dragOffset.x = $event.pageX - (this.$refs["label-areas-pointer"][k].getBoundingClientRect().left + 2.5);
                this.dragOffset.y = $event.pageY - (this.$refs["label-areas-pointer"][k].getBoundingClientRect().top + 2.5);
                this.dragPointer = k;
                this.$emit('drag');
                events.$on("body:click:mouse:up",this.stopDragPointer)
            },
            stopDragPointer() {
                this.dragPointer = -1;
                this.$emit('undrag');
    
                this.label.save();
                events.$off("body:click:mouse:up",this.stopDragPointer)
            },
            labelClass() {

                let classe = this.label.getObjectType();
                if (this.start) {
                    classe += " start ";
                }
                if (this.drag) {
                    classe += " drag ";
                }
                if (this.selected) {
                    classe += " select ";
                }
                if (this.hovered) {
                    classe += " hover ";
                }
                if (this.label.isDrawing) {
                    classe += " draw ";
                }

                return classe
            },
            labelPositionX() {
                let x = parseFloat(this.label.x_coord);
                x *= this.imageData.ratioX;
                return x;
            },
            labelPositionY() {
                let y = parseFloat(this.label.y_coord);
                y *= this.imageData.ratioY;
                return y;
            },
            pointPositionX(x) {
                x *= this.imageData.ratioX;
                return x;
            },
            pointPositionY(y) {
                y *= this.imageData.ratioY;
                return y;
            },
            polygonsPosition() {

                let value = "";
                this.label.points.forEach((point) => {
                    value += this.pointPositionX(point.x) + "," + this.pointPositionY(point.y) + " ";
                })

                if(this.label.isDrawing){
                    // console.log(this.drawMousePosition.x+","+this.drawMousePosition.y+" | "+(this.drawMousePosition.x * this.imageData.ratioX)+","+(this.drawMousePosition.y * this.imageData.ratioX)+" ")
                    value += this.drawMousePosition.x+","+this.drawMousePosition.y+" ";
                }
                
                return value;
            },
            hoverPointer(k){
                let point = this.label.points[k]
                point.hover = true;
                this.$set(this.label.points,k,point)
            },
            unhoverPointer(k){
                let point = this.label.points[k]
                point.hover = false;
                this.$set(this.label.points,k,point)
            },
            stopDraw(){
                // this.events.$emit("interactive-image:area:draw:stop",this.label);
                this.label.undraw()
                this.label.save()
            },
            addPointOnLine(event,k){
                
                let current = this.label.points[k];
                let next = this.label.points[k+1];
                
                if(!next){
                    next = this.label.points[0];
                }
                
                this.label.points.splice(k+1,0,{
                    x: Tools.format(event.pageX - this.imageData.xImage,0,this.imageData.width,this.imageData.ratioX),
                    y: Tools.format(event.pageY - this.imageData.yImage,0,this.imageData.height,this.imageData.ratioY),
                })
    
                this.label.save();
            }
        },
        watch: {
            '$store.state.mouse.position'(value) {
                
                if (this.drag) {

                    if (this.prevMouseX === null) this.prevMouseX = value.x;
                    if (this.prevMouseY === null) this.prevMouseY = value.y;

                    let offsetX = value.x - this.prevMouseX;
                    let offsetY = value.y - this.prevMouseY;

                    offsetX /= this.imageData.ratioX;
                    offsetY /= this.imageData.ratioY;

                    offsetX = Math.round(offsetX);
                    offsetY = Math.round(offsetY);

                    this.label.points.forEach((point, k) => {
                        point.x += offsetX;
                        point.y += offsetY;
                    })

                    this.prevMouseX = value.x;
                    this.prevMouseY = value.y;
    
                    this.dragMove = true;

                }

                if(this.dragPointer > -1){

                    this.label.points[this.dragPointer].x = Tools.format(value.x,0,this.imageData.width,this.imageData.ratioX)
                    this.label.points[this.dragPointer].y = Tools.format(value.y,0,this.imageData.height,this.imageData.ratioY)

                }
                
                if(this.label.isDrawing){
                    this.drawMousePosition = {
                        x : value.x,
                        y : value.y
                    }
                }
            },
            '$store.state.mouse.clickPosition'(value){
    
                if(!this.label.isDrawing) return;
                
                this.label.points.push({
                    x: Tools.format(value.x,0,this.imageData.width,this.imageData.ratioX),
                    y: Tools.format(value.y,0,this.imageData.height,this.imageData.ratioY),
                })
            },
            'imageData.zoom'(){
                this.$forceUpdate();
            },
            'imageData.width'(){
                this.$forceUpdate();
            },
            'imageData.height'(){
                this.$forceUpdate();
            },
        },
    }
</script>
